

export default {

    stockistPackages(state){
        return state.stockistPackages
    },

    stockistPackage(state){
        return state.stockistPackage
    }
}